import { useEffect, useRef, useState } from "react";

const Carousel = (props) => {
  const imgList = props.listImages;
  const timerEnabled = (props?.enableTimer || false);
  const bannerHeight = (props?.height ? ("--" + props.height) : "--h-150");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState("next");

  const carouselContainer = useRef();
  const carouselInner = useRef();
  const imgContainer = useRef();
  const pageInfo = useRef();
  const itemInfoContainer = useRef();
  const totalImages = imgList.length;
  
  const calculatePages = () =>{
    let tPages = 0;
    const tPagesMin = totalImages / (carouselContainer.current.getBoundingClientRect().width/imgContainer.current.getBoundingClientRect().width);
    const tPagesExtra = (tPagesMin - Math.floor(tPagesMin))>0 ? 1 : 0;
    tPages=Math.floor(tPagesMin)+tPagesExtra;
    if (tPages<=0) tPages=1;

    setCurrentPage(1)
    setTotalPages(tPages);
    setCurrentIndex(0);
    updateCarousel (0,0);

    pageInfo.current.innerText = "1 de " + tPages;
  }

  const prevImage = () => {
    if (currentPage<=1) return false;
    updateCarousel(-1, (currentIndex - 1 + totalImages) % totalImages);
    return true;
  }

  const nextImage = () => {
    if (currentPage>=totalPages) return false;
    updateCarousel(+1, (currentIndex + 1) % totalImages);
    return true;
  }

  const updateCarousel = (pageDirection, curIndex) => {
    setCurrentIndex (curIndex);
    setCurrentPage(currentPage + pageDirection);
    
    const offset = -curIndex * 100;
    carouselInner.current.style.transform = `translateX(${offset}%)`;
    pageInfo.current.innerText = currentPage + pageDirection + " de " + totalPages;
  }

  setTimeout(() => {
    if (!timerEnabled || totalPages===1) return;
    if (direction==="next"){
      if (!nextImage()) {
        setDirection("prev");
        prevImage();
      }
    }else if (direction==="prev"){
      if (!prevImage()) {
        setDirection("next");
        nextImage();
      }
    }
  }, 3000);

  const showInfo = (e) => {
    itemInfoContainer.current.innerHTML = "";
    const item = e.target.nodeName==="FIGURE" ? e.target.firstChild : e.target;
    if (!item || item?.nodeName!=="IMG") return;
    const descrip = item.getAttribute("alt");
    if (!descrip) return;
    itemInfoContainer.current.innerHTML = descrip;
    itemInfoContainer.current.style.top = item.offsetTop + 5 + "px";
    itemInfoContainer.current.style.left = item.getBoundingClientRect().left - 10 + "px";
  };

  useEffect(() => {
    calculatePages();
    window.addEventListener('resize', calculatePages);
    return () => {
      window.removeEventListener('resize', calculatePages);
    };
  }, []); 

  return (  
      <div className={"carousel__container " + bannerHeight} ref={carouselContainer}>
        <div className={"carousel-inner " + bannerHeight} ref={carouselInner} >
        {imgList.map (item => {
            return(
              <figure key={Math.floor(Math.random() * 1000000)} className="carousel__item-image-container" ref={imgContainer} onMouseOver={e=>showInfo(e)}>
                 <img key={Math.floor(Math.random() * 1000000)} src={item.image} alt={item.descrip} className="carousel__item-image" loading="lazy" onMouseOver={e=>showInfo(e)}/>
              </figure>
            )
          })
        }
        </div>
        <div className="carousel-page-counter" ref={pageInfo}>1 de 1</div>
        <div ref={itemInfoContainer} className="carousel__info-container"></div>

        <button className={"carousel-btn prev" + (timerEnabled ? " --btn-hidden" : "")} onClick={(e)=>prevImage()}>&#10094;</button>
        <button className={"carousel-btn next" + (timerEnabled ? " --btn-hidden" : "")} onClick={(e)=>nextImage()}>&#10095;</button>
      </div>
  );
}

export default Carousel;